import { Outlet } from 'react-router-dom';
import DocumentHeader from './JobHeader';

const JobsListing = () => {

  return (
    <>
      <DocumentHeader />
      {/* <Outlet /> */}

    </>

  );
};

export default JobsListing;
